const image = `
  name
  src
  alt`;

export default image;
